module.exports = __webpack_public_path__ + "static/par-moon-nobg.383d7886.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/par-moon-nobg.png
// module id = 381
// module chunks = 35783957827783 114276838955818